
/**
 * Carousel styling utilities
 * Responsible for applying consistent styling to carousel elements
 */

// Function to prevent layout shifts by enforcing consistent styling
export const preventLayoutShifts = () => {
  // Set essential CSS properties directly on elements
  const applyConsistentStyling = () => {
    // Force consistent styling on slides
    document.querySelectorAll('.swiper-slide').forEach(slide => {
      const slideElement = slide as HTMLElement;
      slideElement.style.marginRight = '30px';
      slideElement.style.padding = '0';
      slideElement.style.width = 'auto';
      slideElement.style.maxWidth = '280px';
      slideElement.style.display = 'flex';
      slideElement.style.justifyContent = 'center';
    });
    
    // Force wrapper to have correct styles
    const wrapper = document.querySelector('.swiper-wrapper');
    if (wrapper) {
      const wrapperElement = wrapper as HTMLElement;
      wrapperElement.style.transitionTimingFunction = 'linear';
    }
    
    // Make sure images have consistent dimensions
    document.querySelectorAll('.swiper-slide img').forEach(img => {
      const imgElement = img as HTMLImageElement;
      imgElement.style.maxHeight = '220px';
      imgElement.style.width = 'auto';
      imgElement.style.objectFit = 'contain';
      imgElement.style.padding = '0';
    });
  };
  
  // Run immediately and after a delay to ensure styles are applied
  applyConsistentStyling();
  setTimeout(applyConsistentStyling, 500);
};
